"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SvgAccount_1 = require("./SvgAccount");
exports.SvgAccount = SvgAccount_1.default;
var SvgAccountFilled_1 = require("./SvgAccountFilled");
exports.SvgAccountFilled = SvgAccountFilled_1.default;
var SvgAddCircleFilled_1 = require("./SvgAddCircleFilled");
exports.SvgAddCircleFilled = SvgAddCircleFilled_1.default;
var SvgAddCircle_1 = require("./SvgAddCircle");
exports.SvgAddCircle = SvgAddCircle_1.default;
var SvgAddSquare_1 = require("./SvgAddSquare");
exports.SvgAddSquare = SvgAddSquare_1.default;
var SvgAddSquareFilled_1 = require("./SvgAddSquareFilled");
exports.SvgAddSquareFilled = SvgAddSquareFilled_1.default;
var SvgAlert_1 = require("./SvgAlert");
exports.SvgAlert = SvgAlert_1.default;
var SvgAlertFilled_1 = require("./SvgAlertFilled");
exports.SvgAlertFilled = SvgAlertFilled_1.default;
var SvgArrowUp_1 = require("./SvgArrowUp");
exports.SvgArrowUp = SvgArrowUp_1.default;
var SvgArrowUpFilled_1 = require("./SvgArrowUpFilled");
exports.SvgArrowUpFilled = SvgArrowUpFilled_1.default;
var SvgArrowRight_1 = require("./SvgArrowRight");
exports.SvgArrowRight = SvgArrowRight_1.default;
var SvgArrowRightFilled_1 = require("./SvgArrowRightFilled");
exports.SvgArrowRightFilled = SvgArrowRightFilled_1.default;
var SvgArrowDown_1 = require("./SvgArrowDown");
exports.SvgArrowDown = SvgArrowDown_1.default;
var SvgArrowDownFilled_1 = require("./SvgArrowDownFilled");
exports.SvgArrowDownFilled = SvgArrowDownFilled_1.default;
var SvgArrowLeft_1 = require("./SvgArrowLeft");
exports.SvgArrowLeft = SvgArrowLeft_1.default;
var SvgArrowLeftFilled_1 = require("./SvgArrowLeftFilled");
exports.SvgArrowLeftFilled = SvgArrowLeftFilled_1.default;
var SvgBadge_1 = require("./SvgBadge");
exports.SvgBadge = SvgBadge_1.default;
var SvgBadgeFilled_1 = require("./SvgBadgeFilled");
exports.SvgBadgeFilled = SvgBadgeFilled_1.default;
var SvgBookmark_1 = require("./SvgBookmark");
exports.SvgBookmark = SvgBookmark_1.default;
var SvgBookmarkFilled_1 = require("./SvgBookmarkFilled");
exports.SvgBookmarkFilled = SvgBookmarkFilled_1.default;
var SvgBuilding_1 = require("./SvgBuilding");
exports.SvgBuilding = SvgBuilding_1.default;
var SvgBuildingFilled_1 = require("./SvgBuildingFilled");
exports.SvgBuildingFilled = SvgBuildingFilled_1.default;
var SvgBusiness_1 = require("./SvgBusiness");
exports.SvgBusiness = SvgBusiness_1.default;
var SvgBusinessFilled_1 = require("./SvgBusinessFilled");
exports.SvgBusinessFilled = SvgBusinessFilled_1.default;
var SvgCalendar_1 = require("./SvgCalendar");
exports.SvgCalendar = SvgCalendar_1.default;
var SvgCalendarFilled_1 = require("./SvgCalendarFilled");
exports.SvgCalendarFilled = SvgCalendarFilled_1.default;
var SvgCamera_1 = require("./SvgCamera");
exports.SvgCamera = SvgCamera_1.default;
var SvgCameraFilled_1 = require("./SvgCameraFilled");
exports.SvgCameraFilled = SvgCameraFilled_1.default;
var SvgCart_1 = require("./SvgCart");
exports.SvgCart = SvgCart_1.default;
var SvgCartFilled_1 = require("./SvgCartFilled");
exports.SvgCartFilled = SvgCartFilled_1.default;
var SvgCategory_1 = require("./SvgCategory");
exports.SvgCategory = SvgCategory_1.default;
var SvgCategoryFilled_1 = require("./SvgCategoryFilled");
exports.SvgCategoryFilled = SvgCategoryFilled_1.default;
var SvgChallenge_1 = require("./SvgChallenge");
exports.SvgChallenge = SvgChallenge_1.default;
var SvgChallengeFilled_1 = require("./SvgChallengeFilled");
exports.SvgChallengeFilled = SvgChallengeFilled_1.default;
var SvgChefHat_1 = require("./SvgChefHat");
exports.SvgChefHat = SvgChefHat_1.default;
var SvgChefHatFilled_1 = require("./SvgChefHatFilled");
exports.SvgChefHatFilled = SvgChefHatFilled_1.default;
var SvgCloseCircle_1 = require("./SvgCloseCircle");
exports.SvgCloseCircle = SvgCloseCircle_1.default;
var SvgCloseCircleFilled_1 = require("./SvgCloseCircleFilled");
exports.SvgCloseCircleFilled = SvgCloseCircleFilled_1.default;
var SvgCoupon_1 = require("./SvgCoupon");
exports.SvgCoupon = SvgCoupon_1.default;
var SvgCouponFilled_1 = require("./SvgCouponFilled");
exports.SvgCouponFilled = SvgCouponFilled_1.default;
var SvgCreditCard_1 = require("./SvgCreditCard");
exports.SvgCreditCard = SvgCreditCard_1.default;
var SvgCreditCardFilled_1 = require("./SvgCreditCardFilled");
exports.SvgCreditCardFilled = SvgCreditCardFilled_1.default;
var SvgDelete_1 = require("./SvgDelete");
exports.SvgDelete = SvgDelete_1.default;
var SvgDeleteFilled_1 = require("./SvgDeleteFilled");
exports.SvgDeleteFilled = SvgDeleteFilled_1.default;
var SvgDeliveryBike_1 = require("./SvgDeliveryBike");
exports.SvgDeliveryBike = SvgDeliveryBike_1.default;
var SvgDeliveryBikeFilled_1 = require("./SvgDeliveryBikeFilled");
exports.SvgDeliveryBikeFilled = SvgDeliveryBikeFilled_1.default;
var SvgDeliveryVan_1 = require("./SvgDeliveryVan");
exports.SvgDeliveryVan = SvgDeliveryVan_1.default;
var SvgDeliveryVanFilled_1 = require("./SvgDeliveryVanFilled");
exports.SvgDeliveryVanFilled = SvgDeliveryVanFilled_1.default;
var SvgDineIn_1 = require("./SvgDineIn");
exports.SvgDineIn = SvgDineIn_1.default;
var SvgDineInFilled_1 = require("./SvgDineInFilled");
exports.SvgDineInFilled = SvgDineInFilled_1.default;
var SvgDislike_1 = require("./SvgDislike");
exports.SvgDislike = SvgDislike_1.default;
var SvgDislikeFilled_1 = require("./SvgDislikeFilled");
exports.SvgDislikeFilled = SvgDislikeFilled_1.default;
var SvgDonate_1 = require("./SvgDonate");
exports.SvgDonate = SvgDonate_1.default;
var SvgDonateFilled_1 = require("./SvgDonateFilled");
exports.SvgDonateFilled = SvgDonateFilled_1.default;
var SvgEdit_1 = require("./SvgEdit");
exports.SvgEdit = SvgEdit_1.default;
var SvgEditFilled_1 = require("./SvgEditFilled");
exports.SvgEditFilled = SvgEditFilled_1.default;
var SvgFavourite_1 = require("./SvgFavourite");
exports.SvgFavourite = SvgFavourite_1.default;
var SvgFavouriteFilled_1 = require("./SvgFavouriteFilled");
exports.SvgFavouriteFilled = SvgFavouriteFilled_1.default;
var SvgFilter_1 = require("./SvgFilter");
exports.SvgFilter = SvgFilter_1.default;
var SvgFilterFilled_1 = require("./SvgFilterFilled");
exports.SvgFilterFilled = SvgFilterFilled_1.default;
var SvgFlash_1 = require("./SvgFlash");
exports.SvgFlash = SvgFlash_1.default;
var SvgFlashFilled_1 = require("./SvgFlashFilled");
exports.SvgFlashFilled = SvgFlashFilled_1.default;
var SvgGift_1 = require("./SvgGift");
exports.SvgGift = SvgGift_1.default;
var SvgGiftFilled_1 = require("./SvgGiftFilled");
exports.SvgGiftFilled = SvgGiftFilled_1.default;
var SvgGlutenFree_1 = require("./SvgGlutenFree");
exports.SvgGlutenFree = SvgGlutenFree_1.default;
var SvgGlutenFreeFilled_1 = require("./SvgGlutenFreeFilled");
exports.SvgGlutenFreeFilled = SvgGlutenFreeFilled_1.default;
var SvgHalal_1 = require("./SvgHalal");
exports.SvgHalal = SvgHalal_1.default;
var SvgHalalFilled_1 = require("./SvgHalalFilled");
exports.SvgHalalFilled = SvgHalalFilled_1.default;
var SvgHealthierChoice_1 = require("./SvgHealthierChoice");
exports.SvgHealthierChoice = SvgHealthierChoice_1.default;
var SvgHealthierChoiceFilled_1 = require("./SvgHealthierChoiceFilled");
exports.SvgHealthierChoiceFilled = SvgHealthierChoiceFilled_1.default;
var SvgHelp_1 = require("./SvgHelp");
exports.SvgHelp = SvgHelp_1.default;
var SvgHelpFilled_1 = require("./SvgHelpFilled");
exports.SvgHelpFilled = SvgHelpFilled_1.default;
var SvgHide_1 = require("./SvgHide");
exports.SvgHide = SvgHide_1.default;
var SvgHideFilled_1 = require("./SvgHideFilled");
exports.SvgHideFilled = SvgHideFilled_1.default;
var SvgHome_1 = require("./SvgHome");
exports.SvgHome = SvgHome_1.default;
var SvgHomeFilled_1 = require("./SvgHomeFilled");
exports.SvgHomeFilled = SvgHomeFilled_1.default;
var SvgInfo_1 = require("./SvgInfo");
exports.SvgInfo = SvgInfo_1.default;
var SvgInfoFilled_1 = require("./SvgInfoFilled");
exports.SvgInfoFilled = SvgInfoFilled_1.default;
var SvgLike_1 = require("./SvgLike");
exports.SvgLike = SvgLike_1.default;
var SvgLikeFilled_1 = require("./SvgLikeFilled");
exports.SvgLikeFilled = SvgLikeFilled_1.default;
var SvgLinkOut_1 = require("./SvgLinkOut");
exports.SvgLinkOut = SvgLinkOut_1.default;
var SvgLinkOutFilled_1 = require("./SvgLinkOutFilled");
exports.SvgLinkOutFilled = SvgLinkOutFilled_1.default;
var SvgList_1 = require("./SvgList");
exports.SvgList = SvgList_1.default;
var SvgListFilled_1 = require("./SvgListFilled");
exports.SvgListFilled = SvgListFilled_1.default;
var SvgLocation_1 = require("./SvgLocation");
exports.SvgLocation = SvgLocation_1.default;
var SvgLocationFilled_1 = require("./SvgLocationFilled");
exports.SvgLocationFilled = SvgLocationFilled_1.default;
var SvgLocationPin_1 = require("./SvgLocationPin");
exports.SvgLocationPin = SvgLocationPin_1.default;
var SvgLocationPinFilled_1 = require("./SvgLocationPinFilled");
exports.SvgLocationPinFilled = SvgLocationPinFilled_1.default;
var SvgLogin_1 = require("./SvgLogin");
exports.SvgLogin = SvgLogin_1.default;
var SvgLoginFilled_1 = require("./SvgLoginFilled");
exports.SvgLoginFilled = SvgLoginFilled_1.default;
var SvgLogout_1 = require("./SvgLogout");
exports.SvgLogout = SvgLogout_1.default;
var SvgLogoutFilled_1 = require("./SvgLogoutFilled");
exports.SvgLogoutFilled = SvgLogoutFilled_1.default;
var SvgIdentity_1 = require("./SvgIdentity");
exports.SvgIdentity = SvgIdentity_1.default;
var SvgIdentityFilled_1 = require("./SvgIdentityFilled");
exports.SvgIdentityFilled = SvgIdentityFilled_1.default;
var SvgMenuHamb_1 = require("./SvgMenuHamb");
exports.SvgMenuHamb = SvgMenuHamb_1.default;
var SvgMenuHambFilled_1 = require("./SvgMenuHambFilled");
exports.SvgMenuHambFilled = SvgMenuHambFilled_1.default;
var SvgMinusCircle_1 = require("./SvgMinusCircle");
exports.SvgMinusCircle = SvgMinusCircle_1.default;
var SvgMinusCircleFilled_1 = require("./SvgMinusCircleFilled");
exports.SvgMinusCircleFilled = SvgMinusCircleFilled_1.default;
var SvgNoInternet_1 = require("./SvgNoInternet");
exports.SvgNoInternet = SvgNoInternet_1.default;
var SvgNoInternetFilled_1 = require("./SvgNoInternetFilled");
exports.SvgNoInternetFilled = SvgNoInternetFilled_1.default;
var SvgNotification_1 = require("./SvgNotification");
exports.SvgNotification = SvgNotification_1.default;
var SvgNotificationFilled_1 = require("./SvgNotificationFilled");
exports.SvgNotificationFilled = SvgNotificationFilled_1.default;
var SvgOrders_1 = require("./SvgOrders");
exports.SvgOrders = SvgOrders_1.default;
var SvgOrdersFilled_1 = require("./SvgOrdersFilled");
exports.SvgOrdersFilled = SvgOrdersFilled_1.default;
var SvgPot_1 = require("./SvgPot");
exports.SvgPot = SvgPot_1.default;
var SvgPotFilled_1 = require("./SvgPotFilled");
exports.SvgPotFilled = SvgPotFilled_1.default;
var SvgPromotion_1 = require("./SvgPromotion");
exports.SvgPromotion = SvgPromotion_1.default;
var SvgPromotionFilled_1 = require("./SvgPromotionFilled");
exports.SvgPromotionFilled = SvgPromotionFilled_1.default;
var SvgQrCode_1 = require("./SvgQrCode");
exports.SvgQrCode = SvgQrCode_1.default;
var SvgQrCodeFilled_1 = require("./SvgQrCodeFilled");
exports.SvgQrCodeFilled = SvgQrCodeFilled_1.default;
var SvgScales_1 = require("./SvgScales");
exports.SvgScales = SvgScales_1.default;
var SvgScalesFilled_1 = require("./SvgScalesFilled");
exports.SvgScalesFilled = SvgScalesFilled_1.default;
var SvgScan_1 = require("./SvgScan");
exports.SvgScan = SvgScan_1.default;
var SvgScanFilled_1 = require("./SvgScanFilled");
exports.SvgScanFilled = SvgScanFilled_1.default;
var SvgSearch_1 = require("./SvgSearch");
exports.SvgSearch = SvgSearch_1.default;
var SvgSearchFilled_1 = require("./SvgSearchFilled");
exports.SvgSearchFilled = SvgSearchFilled_1.default;
var SvgSettings_1 = require("./SvgSettings");
exports.SvgSettings = SvgSettings_1.default;
var SvgSettingsFilled_1 = require("./SvgSettingsFilled");
exports.SvgSettingsFilled = SvgSettingsFilled_1.default;
var SvgShare_1 = require("./SvgShare");
exports.SvgShare = SvgShare_1.default;
var SvgShareFilled_1 = require("./SvgShareFilled");
exports.SvgShareFilled = SvgShareFilled_1.default;
var SvgShow_1 = require("./SvgShow");
exports.SvgShow = SvgShow_1.default;
var SvgShowFilled_1 = require("./SvgShowFilled");
exports.SvgShowFilled = SvgShowFilled_1.default;
var SvgStar_1 = require("./SvgStar");
exports.SvgStar = SvgStar_1.default;
var SvgStarFilled_1 = require("./SvgStarFilled");
exports.SvgStarFilled = SvgStarFilled_1.default;
var SvgStore_1 = require("./SvgStore");
exports.SvgStore = SvgStore_1.default;
var SvgStoreFilled_1 = require("./SvgStoreFilled");
exports.SvgStoreFilled = SvgStoreFilled_1.default;
var SvgSuccess_1 = require("./SvgSuccess");
exports.SvgSuccess = SvgSuccess_1.default;
var SvgSuccessFilled_1 = require("./SvgSuccessFilled");
exports.SvgSuccessFilled = SvgSuccessFilled_1.default;
var SvgTakeaway_1 = require("./SvgTakeaway");
exports.SvgTakeaway = SvgTakeaway_1.default;
var SvgTakeawayFilled_1 = require("./SvgTakeawayFilled");
exports.SvgTakeawayFilled = SvgTakeawayFilled_1.default;
var SvgClock_1 = require("./SvgClock");
exports.SvgClock = SvgClock_1.default;
var SvgClockFilled_1 = require("./SvgClockFilled");
exports.SvgClockFilled = SvgClockFilled_1.default;
var SvgTips_1 = require("./SvgTips");
exports.SvgTips = SvgTips_1.default;
var SvgTipsFilled_1 = require("./SvgTipsFilled");
exports.SvgTipsFilled = SvgTipsFilled_1.default;
var SvgTransFatFree_1 = require("./SvgTransFatFree");
exports.SvgTransFatFree = SvgTransFatFree_1.default;
var SvgTransFatFreeFilled_1 = require("./SvgTransFatFreeFilled");
exports.SvgTransFatFreeFilled = SvgTransFatFreeFilled_1.default;
var SvgTrophy_1 = require("./SvgTrophy");
exports.SvgTrophy = SvgTrophy_1.default;
var SvgTrophyFilled_1 = require("./SvgTrophyFilled");
exports.SvgTrophyFilled = SvgTrophyFilled_1.default;
var SvgUser_1 = require("./SvgUser");
exports.SvgUser = SvgUser_1.default;
var SvgUserFilled_1 = require("./SvgUserFilled");
exports.SvgUserFilled = SvgUserFilled_1.default;
var SvgVegetarian_1 = require("./SvgVegetarian");
exports.SvgVegetarian = SvgVegetarian_1.default;
var SvgVegetarianFilled_1 = require("./SvgVegetarianFilled");
exports.SvgVegetarianFilled = SvgVegetarianFilled_1.default;
var SvgWhisk_1 = require("./SvgWhisk");
exports.SvgWhisk = SvgWhisk_1.default;
var SvgWhiskFilled_1 = require("./SvgWhiskFilled");
exports.SvgWhiskFilled = SvgWhiskFilled_1.default;
var SvgWine_1 = require("./SvgWine");
exports.SvgWine = SvgWine_1.default;
var SvgWineFilled_1 = require("./SvgWineFilled");
exports.SvgWineFilled = SvgWineFilled_1.default;
var SvgArrowDoubleUp_1 = require("./SvgArrowDoubleUp");
exports.SvgArrowDoubleUp = SvgArrowDoubleUp_1.default;
var SvgArrowDoubleRight_1 = require("./SvgArrowDoubleRight");
exports.SvgArrowDoubleRight = SvgArrowDoubleRight_1.default;
var SvgArrowDoubleDown_1 = require("./SvgArrowDoubleDown");
exports.SvgArrowDoubleDown = SvgArrowDoubleDown_1.default;
var SvgArrowDoubleLeft_1 = require("./SvgArrowDoubleLeft");
exports.SvgArrowDoubleLeft = SvgArrowDoubleLeft_1.default;
var SvgAdd_1 = require("./SvgAdd");
exports.SvgAdd = SvgAdd_1.default;
var SvgMinus_1 = require("./SvgMinus");
exports.SvgMinus = SvgMinus_1.default;
var SvgClose_1 = require("./SvgClose");
exports.SvgClose = SvgClose_1.default;
var SvgTick_1 = require("./SvgTick");
exports.SvgTick = SvgTick_1.default;
var SvgMenuMoreHorizontal_1 = require("./SvgMenuMoreHorizontal");
exports.SvgMenuMoreHorizontal = SvgMenuMoreHorizontal_1.default;
var SvgMenuMoreVertical_1 = require("./SvgMenuMoreVertical");
exports.SvgMenuMoreVertical = SvgMenuMoreVertical_1.default;
var SvgHistory_1 = require("./SvgHistory");
exports.SvgHistory = SvgHistory_1.default;
var SvgLoading_1 = require("./SvgLoading");
exports.SvgLoading = SvgLoading_1.default;
var SvgLinkPlus_1 = require("./SvgLinkPlus");
exports.SvgLinkPlus = SvgLinkPlus_1.default;
var SvgLinkPoints_1 = require("./SvgLinkPoints");
exports.SvgLinkPoints = SvgLinkPoints_1.default;
var SvgArrowUpward_1 = require("./SvgArrowUpward");
exports.SvgArrowUpward = SvgArrowUpward_1.default;
var SvgTrendingUp_1 = require("./SvgTrendingUp");
exports.SvgTrendingUp = SvgTrendingUp_1.default;
var SvgDirectionalArrowLeft_1 = require("./SvgDirectionalArrowLeft");
exports.SvgDirectionalArrowLeft = SvgDirectionalArrowLeft_1.default;
var SvgDirectionalArrowRight_1 = require("./SvgDirectionalArrowRight");
exports.SvgDirectionalArrowRight = SvgDirectionalArrowRight_1.default;
var SvgOrderNote_1 = require("./SvgOrderNote");
exports.SvgOrderNote = SvgOrderNote_1.default;
var SvgFacebook_1 = require("./SvgFacebook");
exports.SvgFacebook = SvgFacebook_1.default;
var SvgFacebookDark_1 = require("./SvgFacebookDark");
exports.SvgFacebookDark = SvgFacebookDark_1.default;
var SvgFacebookWhite_1 = require("./SvgFacebookWhite");
exports.SvgFacebookWhite = SvgFacebookWhite_1.default;
var SvgInstagram_1 = require("./SvgInstagram");
exports.SvgInstagram = SvgInstagram_1.default;
var SvgInstagramDark_1 = require("./SvgInstagramDark");
exports.SvgInstagramDark = SvgInstagramDark_1.default;
var SvgInstagramWhite_1 = require("./SvgInstagramWhite");
exports.SvgInstagramWhite = SvgInstagramWhite_1.default;
var SvgApple_1 = require("./SvgApple");
exports.SvgApple = SvgApple_1.default;
var SvgAppleDark_1 = require("./SvgAppleDark");
exports.SvgAppleDark = SvgAppleDark_1.default;
var SvgAppleWhite_1 = require("./SvgAppleWhite");
exports.SvgAppleWhite = SvgAppleWhite_1.default;
var SvgGoogle_1 = require("./SvgGoogle");
exports.SvgGoogle = SvgGoogle_1.default;
var SvgGoogleDark_1 = require("./SvgGoogleDark");
exports.SvgGoogleDark = SvgGoogleDark_1.default;
var SvgGoogleWhite_1 = require("./SvgGoogleWhite");
exports.SvgGoogleWhite = SvgGoogleWhite_1.default;
var SvgSpotify_1 = require("./SvgSpotify");
exports.SvgSpotify = SvgSpotify_1.default;
var SvgSpotifyDark_1 = require("./SvgSpotifyDark");
exports.SvgSpotifyDark = SvgSpotifyDark_1.default;
var SvgSpotifyWhite_1 = require("./SvgSpotifyWhite");
exports.SvgSpotifyWhite = SvgSpotifyWhite_1.default;
var SvgYoutube_1 = require("./SvgYoutube");
exports.SvgYoutube = SvgYoutube_1.default;
var SvgYoutubeDark_1 = require("./SvgYoutubeDark");
exports.SvgYoutubeDark = SvgYoutubeDark_1.default;
var SvgYoutubeWhite_1 = require("./SvgYoutubeWhite");
exports.SvgYoutubeWhite = SvgYoutubeWhite_1.default;
var SvgBack_1 = require("./SvgBack");
exports.SvgBack = SvgBack_1.default;
var SvgBackFilled_1 = require("./SvgBackFilled");
exports.SvgBackFilled = SvgBackFilled_1.default;
var SvgCheck_1 = require("./SvgCheck");
exports.SvgCheck = SvgCheck_1.default;
var SvgProfile_1 = require("./SvgProfile");
exports.SvgProfile = SvgProfile_1.default;
var SvgVerified_1 = require("./SvgVerified");
exports.SvgVerified = SvgVerified_1.default;
//# sourceMappingURL=index.js.map